import React, { useState } from "react";
import { useLoader } from "../../Common/GeneralLoader/GeneralLoaderProvider";
import { submitTransferApi } from "../../../api/api";
import { drupalSettings } from "../../../utils/config";

export const NewTransferConfirmDetails = ({ setStep, payload, setPayload }) => {
  const { showLoader, hideLoader } = useLoader(); // Destructure isLoading, showLoader, and hideLoader
  const [error, setError] = useState(false);

  const formErrors = {
    technical_error: Drupal.t(
      "Sorry, there was an error. Please try again later or reach out to support@nautzero.com."
    ),
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let isValid = true; // Flag to track if all validations pass

    // If any validation failed, prevent form submission
    if (!isValid) {
      return;
    }

    setError(false);

    // --- Prepare FormData for API ---
    const formData = new FormData();

    // Simple fields
    formData.append("type", payload?.flow?.charAt(0).toUpperCase() + payload?.flow?.slice(1));
    formData.append("recipient_name", payload?.recipient);
    formData.append("reference_number", payload?.reference);
    formData.append("category", payload?.category);
    formData.append("subcategory", payload?.subcategory);
    formData.append("charter", payload?.charter);
    formData.append("notes", payload?.notes);
    formData.append("amount", payload?.amount);
    formData.append("store_recipient_details", true); // always true for now
    formData.append("beneficiary_id", payload?.recipientId);

    // beneficiaryFormData as JSON string
    formData.append("payload", JSON.stringify(payload?.beneficiaryFormData));

    // attach file
    formData.append("file", payload?.file);

    // attach uid
    formData.append("uid", drupalSettings?.user?.user_id || drupalSettings?.user?.uid);

    showLoader();

    (async () => {
      try {
        // Call your API to submit the transfer
        const response = await submitTransferApi({ formData });
        console.log("Transfer submitted successfully:", response);
        jQuery(".view-banking").trigger("RefreshView")

        setStep(0.1); // Move to success
      } catch (err) {
        console.error("Failed to submit transfer:", err);
        setError(formErrors?.technical_error);
      } finally {
        hideLoader();
      }
    })();
  };

  return (
    <>
      <div className="create-transfer-header">
        <h4 className="create-transfer-title">
          Recipient <span className="yellow">Summary</span>
        </h4>
      </div>
      <div className="create-transfer-body-content">
        <form className="confirm-details-form">
          <div className="form--item form--group">
            <label>Recipient Type:</label>
            <strong>{payload?.beneficiaryFormData?.beneficiary?.entity_type}</strong>
          </div>
          <div className="form--item form--group">
            <label>Amount:</label>
            <strong>
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: payload?.recipientDetails?.payload?.beneficiary?.bank_details?.account_currency || "USD",
                minimumFractionDigits: 2,
              }).format(payload?.amount)}
            </strong>
          </div>
          {/* <div className="form--item form--group mt--2">
            <label>Transfer Method:</label>
            <strong>{payload?.beneficiaryFormData?.payment_methods?.join(", ")}</strong>
          </div>
          {payload?.beneficiaryFormData?.payment_methods?.includes("LOCAL") ? <div className="form--item form--group">
            <label>(IF LOCAL) Clearing System:</label>
            <strong>--</strong>
          </div> : null} */}
          {
            Object.entries(payload?.beneficiaryFormData?.beneficiary?.bank_details || {}).map(([key, value]) => {
              if (key.startsWith("account_routing_type")) {
                // extract the index (e.g., 1, 2...) to match with value
                const index = key.replace("account_routing_type", "");
                let typeLabel = "";
                if (value == "aba" || value == "iban") {
                  typeLabel = value.toUpperCase();
                }
                else {
                  typeLabel = value.split("_")
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" "); // like "bank_code"
                }
                const typeValue = payload?.beneficiaryFormData?.beneficiary?.bank_details?.[`account_routing_value${index}`];

                return (
                  <div key={key} className="form--item form--group">
                    <label>{typeLabel == "ABA" ? "Account Routing Number" : typeLabel}:</label>
                    <strong>{typeValue}</strong>
                  </div>
                );
              }

              // skip the "value" keys since they are already paired above
              if (key.startsWith("account_routing_value")) return null;

              let label = "";
              if (key == "iban") {
                // special case for IBAN
                label = key.toUpperCase();
              }
              else {
                // normal fields
                label = key
                  .split("_")
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ");
              }

              return (
                <div key={key} className="form--item form--group">
                  <label>{label}:</label>
                  <strong>{value}</strong>
                </div>
              );
            })
          }
          {/* <div className="form--item form--group mt--2">
            <label>Account Holder's Full Name:</label>
            <strong>{payload?.beneficiaryFormData?.beneficiary?.entity_type == "COMPANY" ? payload?.beneficiaryFormData?.beneficiary?.company_name : payload?.beneficiaryFormData?.beneficiary?.first_name + " " + payload?.beneficiaryFormData?.beneficiary?.last_name}</strong>
          </div> */}
          <div className="form--item form--group">
            <label>Recipient's Address:</label>
            <strong>
              {payload?.beneficiaryFormData?.beneficiary?.address ? Object.values(payload?.beneficiaryFormData?.beneficiary?.address)?.reverse()?.join(", ") : "--"}
            </strong>
          </div>
          {error && (
            <div className="popup-has-error">
              <div className="error_messages">{error}</div>
            </div>
          )}
          <div className="create-transfer-actions">
            <button className="secondary__btn" type="submit" onClick={() => setStep(3.1)}>
              Go Back
            </button>
            <button className="primary__btn" type="submit" onClick={handleSubmit}>
              Confirm
            </button>
          </div>
        </form>
      </div>
    </>
  );
};
